<template>
  <v-card>
    <v-toolbar
      color="transparent"
      flat
    >
      <v-toolbar-title>ספקים</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        @click="$router.push(`/partners?countries=${countryId}`)"
        v-if="partners.length"
      >
        כל הספקים ב{{ country.name }}
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-list>
      <v-list-tile v-if="!partners.length">
        <v-list-tile-content>
          <v-list-tile-title>אין ספקים</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="partnerType in partnerTypes"
        :key="'pt' + partnerType._id"
        avatar
        @click="$router.push(`/partners?countries=${countryId}&types=${partnerType._id}&showFullLayout=true`)"
        v-if="partnersByType(partnerType._id)"
      >
        <v-list-tile-avatar>
          <v-avatar :color="partnerType.color">
            <v-icon class="white--text">{{ partnerType.icon || 'home' }}</v-icon>
          </v-avatar>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ partnerType.titlePlural }}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-chip>{{ partnersByType(partnerType._id) }}</v-chip>
        </v-list-tile-action>

      </v-list-tile>
    </v-list>

  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    country() {
      return this.$store.state.entities.countries[this.countryId];
    },
    partners() {
      return this.$store.getters["countries/countryPartners"](this.countryId);
    },
    partnerTypes() {
      return Object.values(this.$store.state.entities.partnerTypes).sort((a, b) => {
        a = a.order ? a.order : 0;
        b = b.order ? b.order : 0;
        return b - a;
      })
    }
  },
  beforeMount() {},
  mounted() {},
  methods: {
    partnersByType(typeId) {
      return this.partners.filter(item => {
        if (item) {
          return item.types.indexOf(typeId) !== -1;
        }
        return false;
      }).length;
    }
  },
  props: ["countryId"],
  components: {},
  watch: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/countries/country/CountryPartners.vue